import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpHeaderResponse,
  HttpParams,
} from "@angular/common/http";
import { environment } from "src/environments/environment";
import { Observable } from "rxjs";
import { ResponsesPageables } from "../../core/models/responesPageables";
import { TokenService } from "src/app/core/services/token.service";
import { DtoReasgineAnalyst } from "src/app/core/models/certificates";
import { endpointsURL } from "src/app/constants/endpointsURL";
import { ValidateVehiculo } from "../models";

@Injectable({
  providedIn: "root",
})
export class CertificatesService {
  env = environment.env;
  certificatesURL = endpointsURL.certificatesURL;
  requestURL = endpointsURL.requestURL;

  constructor(private httpClient: HttpClient) {}

  resetFile;

  public downloadFileOfPetition(
    esHistorico: string,
    field: string,
    peId: string,
    peRelease: string
  ) {
    let params = new HttpParams();
    params = params.append("esHistorico", esHistorico);
    params = params.append("field", field);
    params = params.append("peId", peId);
    params = params.append("peRelease", peRelease);

    return this.httpClient.get(
      `${this.env}/certificateRequest/downloadFileByPeticione`,
      { params: params, responseType: "blob" }
    );
  }

  public getCertificatesMailBoxList(
    filters: string
  ): Observable<ResponsesPageables> {
    return this.httpClient.get<ResponsesPageables>(
      `${this.env}${this.certificatesURL}buzon/list${filters}`
    );
  }

  public getCertificate(id: string): Observable<any> {
    let params = new HttpParams().set("idSolicitud", id);

    return this.httpClient.get<any>(
      `${this.env}${this.certificatesURL}buzon/detail`,
      {
        params: params,
      }
    );
  }

  public updateCertificate(value, files): Observable<any> {
    const fd = new FormData();

    fd.append("updateCertificadoRequest", JSON.stringify(value));
    files.forEach((element, index) => {
      fd.append("files", element.blob, element.name);
    });
    if (files.length == 0) {
      fd.append("files", new Blob([], { type: "text/html" }), "vacio");
    }

    return this.httpClient.put<any>(
      `${this.env}${this.certificatesURL}certificados/buzon/update`,
      fd
    );
  }

  public uploadCertIndividual(filter: string): Observable<any> {
    return this.httpClient.get<any>(
      `${this.env}${this.certificatesURL}/edit${filter}`
    );
  }

  public uploadCertGenerico(datosGroupForm: any, files: any): Observable<any> {
    const fd = new FormData();
    if (
      datosGroupForm.value.documentoGenAdjuntar !== "" &&
      datosGroupForm.value.documentoGenAdjuntar !== undefined
    ) {
      fd.append(
        "_file1",
        datosGroupForm.value.documentoGenAdjuntar,
        files.documentoGenAdjuntar
      );
    } else {
      fd.append(
        "_file1",
        new Blob([], { type: "text/html" }),
        files.documentoGenAdjuntar
      );
    }
    if (
      datosGroupForm.value.documentoGenAdicional !== "" &&
      datosGroupForm.value.documentoGenAdicional !== undefined
    ) {
      fd.append(
        "_file2",
        datosGroupForm.value.documentoGenAdicional,
        files.documentoGenAdicional
      );
    } else {
      fd.append(
        "_file2",
        new Blob([], { type: "text/html" }),
        files.documentoGenAdicional
      );
    }

    let peticionesFiles;
    if (!datosGroupForm.value.documentoGenAdicional) {
      peticionesFiles = [
        { dpCampoid: "PE_FICHATECNICA", dpFichero: files.documentoGenAdjuntar },
      ];
    } else {
      peticionesFiles = [
        { dpCampoid: "PE_FICHATECNICA", dpFichero: files.documentoGenAdjuntar },
        {
          dpCampoid: "PE_DOCADICIONAL",
          dpFichero: files.documentoGenAdicional,
        },
      ];
    }

    let maintenancePeticionesDto = {
      peticionesDto: {
        peMarca: datosGroupForm.value.marca,
        peTcId: "GE",
        peObservaciones: datosGroupForm.value.observaciones,
      },
      detallePeticionesDto: peticionesFiles,
    };
    fd.append(
      "_maintenancePeticionesDto",
      JSON.stringify(maintenancePeticionesDto)
    );

    return this.httpClient.put<any>(
      `${this.env}${this.requestURL}/certificado/generico`,
      fd
    );
  }
  //
  public otrosCertificados(datosGroupForm: any): Observable<any[]> {
    return this.httpClient.post<any>(
      `${this.env}${this.requestURL}/certificado/especifico/otrosCertificados`,
      datosGroupForm
    );
  }
  //

  public validateVehiculoBastidor(dto: ValidateVehiculo): Observable<any> {
    return this.httpClient.post<any>(
      `${this.env}${this.requestURL}/certificado/validacion/bastidor`,
      dto
    );
  }
  public reformasCertificados(datosGroupForm: any): Observable<any[]> {
    return this.httpClient.post<any>(
      `${this.env}${this.requestURL}/certificado/especifico/reformas`,
      datosGroupForm
    );
  }
  //
  public datosEspecificos(
    datosGroupForm: any,
    listOfFieldFile: any,
    fieldsInfo: any,
    allTheFields: any,
    fileDatosEspecificos: any
  ): Observable<any[]> {
    const fd = new FormData();

    let detallePeticionesDtoObjectArray = [];
    let haveFiles = false;
    let fileName = "";
    for (let item in listOfFieldFile) {
      detallePeticionesDtoObjectArray.push({
        dpCampoid: listOfFieldFile[item]["cdId"],
        dpUniqueid: listOfFieldFile[item]["cdUniqueid"],
        dpReforma: listOfFieldFile[item]["cdReforma"],
        dpFichero: datosGroupForm.value[listOfFieldFile[item]["cdUniqueid"]],
        etiqueta: listOfFieldFile[item]["cdTexto"],
      });

      if (
        datosGroupForm.value[listOfFieldFile[item]["cdUniqueid"]] !== "" &&
        datosGroupForm.value[listOfFieldFile[item]["cdUniqueid"]] !== undefined
      ) {
        haveFiles = true;
        fileName =
          listOfFieldFile[item]["cdUniqueid"] !== "-"
            ? listOfFieldFile[item]["cdUniqueid"]
            : datosGroupForm.value[listOfFieldFile[item]["cdUniqueid"]];
        fd.append(
          "_files",
          fileDatosEspecificos[listOfFieldFile[item]["cdUniqueid"]],
          fileName
        );
      }
    }
    if (!haveFiles) {
      fd.append("_files", new Blob([], { type: "text/html" }), "empty");
    }
    for (let item in allTheFields) {
      if (
        allTheFields[item]["cdTipo"] != "FILE" ||
        allTheFields[item]["cdTipo"] != "TEXTO"
      ) {
        detallePeticionesDtoObjectArray.push({
          dpCampoid: allTheFields[item]["cdId"],
          dpUniqueid: allTheFields[item]["cdUniqueid"],
          dpReforma: allTheFields[item]["cdReforma"],
          dpValor: datosGroupForm.value[allTheFields[item]["cdUniqueid"]],
          etiqueta: allTheFields[item]["cdTexto"],
        });
      }
    }
    let maintenancePeticionesDto = {
      detallePeticionesDto: detallePeticionesDtoObjectArray,
      peticionesDto: {
        peBastidor: fieldsInfo.peBastidor,
        peMatricula: fieldsInfo.peMatricula,
        peReId: fieldsInfo.peReId,
        peOtrasReformas: fieldsInfo.peOtrasReformas,
        peTcId: fieldsInfo.peTcId,
      },
    };
    fd.append(
      "_maintenancePeticionesDto",
      JSON.stringify(maintenancePeticionesDto)
    );

    if (fieldsInfo.peTcId == "RE") {
      return this.httpClient.put<any>(
        `${this.env}${this.requestURL}/certificado/especifico/reformas/datosEspecificos`,
        fd
      );
    } else {
      return this.httpClient.put<any>(
        `${this.env}${this.requestURL}/certificado/especifico/otrosCertificados/datosEspecificos`,
        fd
      );
    }
  }
  //

  public uploadOtherDocuments(files: File[]): Observable<string[]> {
    const fd = new FormData();

    files.forEach((file) => {
      fd.append("_files", file, file.name);
    });

    return this.httpClient.put<string[]>(
      `${this.env}${this.requestURL}/certificado/otrosDocumentos`,
      fd
    );
  }

  public getQueryListCertificates(
    filters: string
  ): Observable<ResponsesPageables> {
    return this.httpClient.get<ResponsesPageables>(
      `${this.env}${this.certificatesURL}consulta/list${filters}`
    );
  }

  public getQueryDetailCertificates(id: string) {
    let params = new HttpParams().set("idSolicitud", id);

    return this.httpClient.get<any>(
      `${this.env}${this.certificatesURL}consulta/detail`,
      {
        params: params,
      }
    );
  }

  public getQueryListHistoryCertificates(
    filters: string
  ): Observable<ResponsesPageables> {
    return this.httpClient.get<ResponsesPageables>(
      `${this.env}${this.certificatesURL}consulta/historyList${filters}`
    );
  }

  public getQueryHistoryDetailCertificates(id: string) {
    let params = new HttpParams().set("idSolicitud", id);
    return this.httpClient.get<any>(
      `${this.env}${this.certificatesURL}consulta/historyDetail`,
      {
        params: params,
      }
    );
  }

  public reasignedAnalyst(dto: DtoReasgineAnalyst) {
    return this.httpClient.put<any>(
      `${this.env}${this.certificatesURL}edit/analista`,
      dto
    );
  }

  public getQueryHistoryPreviousCertificates(id: string) {
    let params = new HttpParams().set("idPeticion", id);
    return this.httpClient.get<any>(
      `${this.env}${this.requestURL}/certificado/anteriores`,
      {
        params: params,
      }
    );
  }

  public getPreviousFileCertificates(
    hcId: string,
    hcRelease: string,
    isUnique: string,
    hcCve: string
  ) {
    let params = new HttpParams();
    params = params.set("idPeticion", hcId);
    params = params.set("release", hcRelease);
    params = params.set("isUnique", isUnique);
    params = params.set("cve", hcCve);

    return this.httpClient.get(
      `${this.env}${this.requestURL}/certificado/ficheroAnterior`,
      { params: params }
    );
  }

  public getInfoOfACCFields(id: string) {
    let params = new HttpParams().set("IdAccesorio", id);
    return this.httpClient.get<any>(
      `${this.env}/accesorios/consulta/facturacion`,
      {
        params: params,
      }
    );
  }
}
